var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.formattedValue)?_c('div',{staticClass:"text-xs-left text-input"},[_c('label',{staticClass:"subheading"},[_vm._t("default")],2),_c('div',[_vm._v("\r\n     "+_vm._s(_vm.formattedValue)+"\r\n    "),_c('div')])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }